/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaProfileValueWithLabelText/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import TysiaProfileItem from './TysiaProfileItem/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaProfileValueWithLabelText({
  children,
  viewPath = "/DesignSystem/TysiaProfileElements/TysiaProfileValueWithLabelText",
  marginTop,
  isHorizontal,
  size,
  label,
  value
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let marginTopOrdtSpaceS = marginTop ?? dtSpaceS
let marginTopOrdtSpaceS1 = marginTop ?? dtSpaceS
  return (<React.Fragment
>
<fromFlow.When is={!isHorizontal}>
<div
  data-testid="TysiaProfileValueWithLabelText.Vertical"
  data-view-path={viewPath}
 style={{'--mt-1-Z1Ls1cm': typeof marginTopOrdtSpaceS === 'number' ? `${marginTopOrdtSpaceS}px` : marginTopOrdtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaProfileItem
  viewPath={`${viewPath}/TysiaProfileItem`}
 size={size}
 label={label}
 value={value}
/>
</div>
</fromFlow.When>
<fromFlow.When is={isHorizontal}>
<div
  data-testid="TysiaProfileValueWithLabelText.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-Z1Ls1cm': typeof marginTopOrdtSpaceS1 === 'number' ? `${marginTopOrdtSpaceS1}px` : marginTopOrdtSpaceS1}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaProfileItem
  viewPath={`${viewPath}/TysiaProfileItem`}
 size={size}
 label={label}
 value={value}
/>
</div>
</fromFlow.When>
{children}
</React.Fragment>)
}